import { createActions, createContext, stateSetter } from '@packages/context';
import { Record } from 'immutable';

type state = {
    open: boolean;
};

const initialState = Record<state>({
    open: false,
});

type Actions = 'setOpen' | 'cancel' | 'close' | 'open' | 'show' | 'toggle';

const actions = createActions<Actions>(['setOpen', 'cancel', 'close', 'open', 'show', 'toggle']);

const { Provider, Context } = createContext<state, typeof actions>({
    initialState,
    actions,
    name: 'createDialog',
    debug: false,
    events: {
        onSetOpen: stateSetter('open'),
        onCancel: (state) => state.set('open', false),
        onClose: (state) => state.set('open', false),
        onOpen: (state) => state.set('open', true),
        onShow: (state) => state.set('open', true),
        onToggle: (state) => state.set('open', !state.get('open')),
    },
});

export const DialogContext = Context;
export const DialogProvider = Provider;
